import React, { useId } from 'react';
import './writingJobFlow.css';

const JOBS = [
    { key: 'point', label: '1 Point', question: 'What will this paragraph argue?' },
    { key: 'example', label: '2 Example', question: 'What makes the point concrete?' },
    { key: 'explain', label: '3 Explain', question: 'How does it work? Why does it matter?' },
    { key: 'link', label: '4 Link', question: 'How does this support the position or lead forward?' },
    { key: 'organise', label: '5 Organise the body', question: 'Arrange distinct paragraphs so the argument develops.' }
];
const paragraphJobs = JOBS.slice(0, 4);

export default function WritingJobFlow({ currentJob, onSelectJob, independent = false, bodyPlan = [] }) {
    const prefix = useId();
    const current = JOBS.find(job => job.key === currentJob);
    // A consumer resolves actual native chooser values and task-specific support.
    // Generic job labels never become grammar roles or invented lesson links.
    if (independent || !current) return null;
    const tile = job => <button type="button" className="writing-job-flow__tile" data-writing-job={job.key}
        aria-label={job.label} aria-describedby={prefix + '-' + job.key} aria-pressed={currentJob === job.key}
        onClick={() => onSelectJob?.(job.key)}>
        <span className="writing-job-flow__tile-label">{job.label}</span>
        <span id={prefix + '-' + job.key} className="writing-job-flow__tile-question">{job.question}</span>
        {currentJob === job.key && <span className="writing-job-flow__current-label">Current job</span>}
    </button>;
    return <section className="writing-job-flow selectable" aria-label="Writing-job flow" data-current-job={currentJob}>
        <p role="status" className="writing-job-flow__current">Current job: <strong>{current.label}</strong></p>
        <details className="writing-job-flow__map" open>
            <summary>See how the writing jobs fit together</summary>
            <p className="writing-job-flow__banner">Keep the article's position and purpose in view.</p>
            <section className="writing-job-flow__paragraph" aria-label="Within one paragraph">
                <h4>Within one paragraph</h4>
                <ol className="writing-job-flow__jobs">{paragraphJobs.map((job, index) => <li key={job.key}>
                    {tile(job)}{index < paragraphJobs.length - 1 && <span className="writing-job-flow__arrow" aria-hidden="true">→</span>}
                </li>)}</ol>
            </section>
            <p className="writing-job-flow__persuade">Persuade throughout — help this reader understand and care.</p>
            <section className="writing-job-flow__across" aria-label="Across paragraphs">
                <h4>Across paragraphs</h4>
                {tile(JOBS[4])}
                {bodyPlan.length > 0 && <details className="writing-job-flow__body-plan">
                    <summary>One possible body plan</summary>
                    <ol>{bodyPlan.map(paragraph => <li key={paragraph.id}>
                        <h5>{paragraph.title}</h5><p>{paragraph.focus}</p>
                        <p className="writing-job-flow__plan-jobs">Point · Example · Explain · Link</p>
                    </li>)}</ol>
                </details>}
            </section>
            <aside className="writing-job-flow__review" aria-label="Review">
                <h4>Review</h4>
                <p>Does every sentence develop the point? Does the point support the article's purpose?</p>
            </aside>
            <p className="writing-job-flow__note">Writing jobs, not a five-sentence formula. One sentence may do more than one job.</p>
        </details>
    </section>;
}
